import Vue from 'vue'
import Router from 'vue-router'
import {
  ROUTE_LOGIN,
  ROUTE_DASHBOARD,
  ROUTE_MENU,
  ROUTE_BOXES,
  ROUTE_ADDSONGS,
  ROUTE_PLAYLISTS,
  ROUTE_PLAYLIST,
  ROUTE_PLAYLIST_SCHEDULE,
  ROUTE_PLAYLIST_SCHEDULE_EDIT,
  ROUTE_PLAYLIST_SCHEDULE_ADD,
  ROUTE_PLAYLIST_CREATE,
  ROUTE_PLAYLIST_EDIT,
  ROUTE_JINGLES,
  ROUTE_JINGLE_SCHEDULE,
  ROUTE_JINGLE_SCHEDULE_ADD,
  ROUTE_JINGLE_SCHEDULE_EDIT,
  ROUTE_JUKEBOX,
  ROUTE_REPORTS,
  ROUTE_HELP
} from '@/const/routeNames'
import Login from '@/components/Login'
import Dashboard from '@/components/Dashboard'
import Menu from '@/components/Menu'
import Boxes from '@/components/Boxes'
import Addsongs from '@/components/Addsongs'
import Playlists from '@/components/Playlists'
import Playlist from '@/components/Playlist'
import PlaylistSchedule from '@/components/PlaylistSchedule'
import PlaylistScheduleAddEdit from '@/components/PlaylistScheduleAddEdit'
import PlaylistAddEdit from '@/components/PlaylistAddEdit'
import Jingles from '@/components/Jingles'
import JingleSchedule from '@/components/JingleSchedule'
import JingleScheduleAddEdit from '@/components/JingleScheduleAddEdit'
import Jukebox from '@/components/Jukebox'
import Reports from '@/components/Reports'
import Help from '@/components/Help'
import store from '@/store'

Vue.use(Router)

const router = new Router({
  base: '/m2',
  mode: 'history',
  routes: [
    {
      path: ROUTE_LOGIN,
      name: 'HelloWorld',
      component: Login
    },
    {
      path: ROUTE_DASHBOARD,
      name: 'Dashboard',
      component: Dashboard
    },
    {
      path: ROUTE_MENU,
      name: 'Menu',
      component: Menu
    },
    {
      path: ROUTE_BOXES,
      name: 'Boxes',
      component: Boxes
    },
    {
      path: ROUTE_ADDSONGS,
      name: 'Addsongs',
      component: Addsongs
    },
    {
      path: ROUTE_PLAYLISTS,
      name: 'Playlists',
      component: Playlists
    },
    {
      path: ROUTE_PLAYLIST_CREATE,
      name: 'PlaylistCreate',
      component: PlaylistAddEdit
    },
    {
      path: ROUTE_PLAYLIST_EDIT,
      name: 'PlaylistEdit',
      component: PlaylistAddEdit
    },
    {
      path: ROUTE_PLAYLIST,
      name: 'Playlist',
      component: Playlist
    },
    {
      path: ROUTE_PLAYLIST_SCHEDULE,
      name: 'PlaylistSchedule',
      component: PlaylistSchedule
    },
    {
      path: ROUTE_PLAYLIST_SCHEDULE_ADD,
      name: 'PlaylistScheduleAdd',
      component: PlaylistScheduleAddEdit
    },
    {
      path: ROUTE_PLAYLIST_SCHEDULE_EDIT,
      name: 'PlaylistScheduleEdit',
      component: PlaylistScheduleAddEdit
    },
    {
      path: ROUTE_JINGLES,
      name: 'Jingles',
      component: Jingles
    },
    {
      path: ROUTE_JINGLE_SCHEDULE,
      name: 'JingleSchedule',
      component: JingleSchedule
    },
    {
      path: ROUTE_JINGLE_SCHEDULE_ADD,
      name: 'JingleScheduleAdd',
      component: JingleScheduleAddEdit
    },
    {
      path: ROUTE_JINGLE_SCHEDULE_EDIT,
      name: 'JingleScheduleEdit',
      component: JingleScheduleAddEdit
    },
    {
      path: ROUTE_JUKEBOX,
      name: 'Jukebox',
      component: Jukebox
    },
    {
      path: ROUTE_REPORTS,
      name: 'Reports',
      component: Reports
    },
    {
      path: ROUTE_HELP,
      name: 'Help',
      component: Help
    }
  ]
})

router.beforeEach((to, from, next) => {
  if (store.state.auth.authorized === false && to.path !== ROUTE_LOGIN) {
    next(ROUTE_LOGIN)
  } else {
    next()
  }
})

export default router



// WEBPACK FOOTER //
// ./src/router/index.js